import { Directive, Input, TemplateRef, ViewContainerRef, OnChanges } from "@angular/core";
import { AuthenticationService } from "@app/core/authentication";
import { LogicOp, Page } from '@app/core/authentication/permission';

@Directive({
    selector: '[allowed-page]',
})
export class AllowedPageDirective implements OnChanges {

    private _page: Page;
    private _isAllowed: boolean;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private authenticationService: AuthenticationService) {
    }

    public ngOnChanges() {
        this.isPageAllowed();
    }

    @Input('allowed-page')
    set allowedPage(page: Page) {
        this._page = page;
    }

    private isPageAllowed(): void {

        const wasAllowed = this._isAllowed;

        this._isAllowed =
            this.authenticationService.currentUserValue.isAllowedToOpenPage(this._page);

        if (wasAllowed !== this._isAllowed) {
            if (this._isAllowed) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            } else {
                this.viewContainer.clear();
            }
        }
    }

}